export { default } from './BrandHeroWrapper';
